import { KanopyMenuAdView } from '../../ecmascript/components/kanopy-menu-ad/kanopy-menu-ad-view';
import { DropdownWatcher } from '../../ecmascript/util/dropdownWatcher';
import { isSelectEvent } from '../../ecmascript/util/isSelectEvent';

/* eslint no-invalid-this: "off" */
/* eslint func-style: "off" */
var openMenu = 'main';

var trimOutsideForwardSlashes = function (s) {
    if (s) {
        return s.replace(/^\/?(.*?)\/?$/, '$1');
    } else {
        return s;
    }
};

var getFormWidth = function ($elem) {
    return $('.js-mobileSearchContainer').width() - $elem.width() - 30;
};

var getInputWidth = function ($elem) {
    return (
        $('.js-mobileSearchContainer').width() -
        $('.js-mobileNavSearchIcon').width() -
        $elem.width() -
        40
    );
};

const renderKanopyAd = () => {
    const menuAdEl = $('.kanopy-menu-ad-container');
    if (menuAdEl) {
        new KanopyMenuAdView({
            el: menuAdEl,
            isTolinoDevice: window.OverDrive.isTolinoDevice,
            kanopySignUpUrl: window.OverDrive.kanopySignUpUrl,
        });
    }
};

const closeNavDropdowns = () => {
    if ($('.js-advancedSearchContainer').is(':visible')) {
        $('.js-advancedSearchContainer').hide();
        $('.js-advancedSearchContainer').attr('aria-hidden', 'true');
        $('.js-mobileSearchInput').attr('aria-expanded', 'false');
    }
    if ($('.js-desktopSearchContainer').is(':visible')) {
        $('.js-desktopSearchContainer').hide();
        $('.js-desktopSearchContainer').attr('aria-hidden', 'true');
        $('.js-toggleSearch').attr('aria-expanded', 'false');
    }
    if (window.notificationDrawer && window.notificationDrawer.isOpen) {
        window.notificationDrawer.close();
    }
};

$(document).ready(function () {
    // Don't submit a blank search
    $(document).on('keyup', 'input[data-search]', function (e) {
        if (e.key == 'Enter') {
            if ($(this).val() != '') {
                $(this).parents('form').submit();
            } else {
                e.preventDefault();
                return false;
            }
        }
    });

    // if the user is not on the home page...
    var currentPath = trimOutsideForwardSlashes(location.pathname);
    var homePath = trimOutsideForwardSlashes(window.url(window.routes.home));
    if (currentPath !== homePath) {
        // ...then underline the nav link of the current page if it exists
        // TODO: Refactor away these general selectors and do it more cleanly
        $('a[href*="' + currentPath + '"]').addClass('selected');
        $('a[href*="' + currentPath + '"] li span').addClass('selected');
    }

    if ($(document).width() > 870) {
        $('.js-toggleRow').removeClass('row');
    }

    // Fit mobile search to container
    $('.js-mobileSearchForm').css(
        'width',
        getFormWidth($('.js-mobileNavIconContainer')) + 'px'
    );
    $('.js-mobileSearchInput').css(
        'width',
        getInputWidth($('.js-mobileNavIconContainer')) + 'px'
    );
});

$('.js-mobileSearchInput')
    .on('touchstart click', function () {
        setTimeout(function () {
            if (!$('.js-advancedSearchContainer').is(':visible')) {
                $('.js-advancedSearchContainer').toggle();
                if (window.toaster) window.toaster._stickToast();
            }
            $('.js-mobileSearchInput').attr('aria-expanded', 'true');

            if ($('.js-account-menu-mobile').hasClass('is-open')) {
                window.AccountMenuMobileView.close();
                if (window.toaster) window.toaster._stickToast();
            }
        }, 1);
    })
    .on('focusout', function () {
        setTimeout(function () {
            var focused = $(document.activeElement);
            if (
                !focused.hasClass('js-advancedSearchLink') &&
                $('.js-advancedSearchContainer').css('display') == 'block' &&
                !focused.hasClass('js-mobileSearchInput')
            ) {
                if (window.toaster) window.toaster._stickToast();
            }
        }, 1);
    });

$('#nav-search-mobile').on('focusin keydown', function (e) {
    if (e.key === 'Tab' || e.type === 'focusin') {
        $('.js-mobileSearchInput').attr('aria-expanded', 'true');
        $('.js-advancedSearchContainer').attr('aria-hidden', 'false');
    }
});

// mobile search focusout
$('.js-MobileNav-interactable').on('focusout', function () {
    setTimeout(function () {
        var focused = $(document.activeElement);
        if (
            !focused.hasClass('js-MobileNav-interactable') &&
            !focused.hasClass('js-advancedSearchLink')
        ) {
            $('.js-advancedSearchContainer').hide();
            $('.js-advancedSearchContainer').attr('aria-hidden', 'true');
            $('.js-mobileSearchInput').attr('aria-expanded', 'false');
        }
    }, 1);
});

// desktop right nav focusout for search container
$('.js-Nav-interactable').on('focusout', function (e) {
    setTimeout(function () {
        e.stopPropagation();
        var focused = $(document.activeElement);
        if (
            !focused.hasClass('js-Nav-interactable') &&
            !focused.hasClass('js-quickSearchInput')
        ) {
            $('.js-desktopSearchContainer').hide();
            $('.js-desktopSearchContainer').attr('aria-hidden', 'true');
            $('.js-toggleSearch').attr('aria-expanded', 'false');
        }
    }, 1);
});

// Handle mobile nav menu
$('.js-mobileMenu').on(
    'tap click',
    _.debounce(function (e) {
        e.preventDefault();
        e.stopPropagation();

        // LHTNG-3938 - this is a last ditch hack.  The notification drawer uses a click handler on <body> to close itself, but
        // this menu doesn't play nice with that pattern. I tried to clean that up and allow the click to propagate but that
        // revealed a huge mess of issues that we can't tackle now.
        if (
            window.featureManager.isEnabled('Notifications') &&
            window.notificationDrawer
        ) {
            window.notificationDrawer.close();
        }
        if ($('.MobileNav-advancedSearchContainer').css('display') == 'block') {
            $('.js-advancedSearchContainer').hide();
            $('.js-mobileSearchInput').attr('aria-expanded', 'false');
        }

        renderKanopyAd();

        setTimeout(function () {
            if (window.toaster) window.toaster._stickToast();
        }, 0);

        if ($('.icon-search-nav').hasClass('expanded')) {
            $('.icon-search-nav')
                .removeClass('expanded')
                .addClass('unexpanded');
        }

        $(
            '#mobile-nav-foundation-dropdown[data-menu="' + openMenu + '"]'
        ).toggle();

        if ($('.js-account-menu-mobile').hasClass('is-open')) {
            window.AccountMenuMobileView.close();
        }

        if ($(this).attr('id') == 'hamburger') {
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        }
        return false;
    }, 350)
);

// Advantage tout
$('div#dropAccount.large')
    .on('opened.fndtn.dropdown', function () {
        $('.top-bar').css('overflow', 'visible');
        var link = $(this).find('a');
        $(this).find('p').attr('tabindex', link.attr('data-tab'));
        link.attr('tabindex', link.attr('data-tab'));
    })
    .on('closed.fndtn.dropdown', function () {
        $(this).find('p').attr('tabindex', -1);
        $(this).find('a').attr('tabindex', -1);
    });

$(window).resize(function () {
    var width = $(document).width();
    if (width <= 855) {
        $('.js-toggleRow').addClass('row');

        var searchForm = $('.js-mobileSearchForm');
        var searchInput = $('.js-mobileSearchInput');
        if (searchForm.hasClass('is-expanded')) {
            var searchContainer = $('.js-searchControlContainer');
            searchForm.css('width', getFormWidth($(searchContainer)) + 'px');
            searchInput.css('width', getInputWidth($(searchContainer)) + 'px');
        } else {
            var iconContainer = $('.js-mobileNavIconContainer');
            searchForm.css('width', getFormWidth($(iconContainer)) + 'px');
            searchInput.css('width', getInputWidth($(iconContainer)) + 'px');
        }
    } else {
        $('.js-toggleRow').removeClass('row');
    }
});

function exitSearchMode() {
    $('.js-searchControlContainer').addClass('u-hideMe');
    var iconContainer = $('.js-mobileNavIconContainer');
    iconContainer.removeClass('u-hideMe');
    $('.js-mobileSearchForm')
        .removeClass('is-expanded')
        .addClass('is-unexpanded')
        .css('width', getFormWidth(iconContainer) + 'px');
    $('.js-mobileSearchInput').css(
        'width',
        getInputWidth($(iconContainer)) + 'px'
    );
}

function enterSearchMode() {
    var searchContainer = $('.js-searchControlContainer');
    searchContainer.removeClass('u-hideMe');
    $('.js-mobileNavIconContainer').addClass('u-hideMe');
    $('.js-mobileSearchForm')
        .addClass('is-expanded')
        .removeClass('is-unexpanded')
        .css('width', getFormWidth(searchContainer) + 'px');
    $('.js-mobileSearchInput').css(
        'width',
        getInputWidth($(searchContainer)) + 'px'
    );
}

// Clear mobile search bar
$('.js-clearMobileSearch').on('click', function (e) {
    if (e.type === 'click') {
        $('.js-mobileSearchInput').val('').trigger('keyup').focus();
        $('.Nav-searchInput').val('');
        exitSearchMode();
        $('.js-advancedSearchContainer').show();
    }
});

$('.js-mobileSearchInput')
    .on('keyup', function () {
        enterSearchMode();

        if ($(this).val().length === 0) {
            exitSearchMode();
            $('.js-advancedSearchContainer').show();
        }
    })
    .on('click focus', function () {
        if ($(this).val().length > 0) {
            enterSearchMode();
        }
        $('.js-advancedSearchContainer').show();
    })
    .on('blur', function () {
        // When mobile search input loses focus, unhide mobile account menu
        $('.js-account-menu-link, .js-account-menu-mobile').removeClass(
            'hideMeImportant'
        );
    });

$(document).click(function (e) {
    if (!$(e.target).parent().parent().hasClass('js-mobileSearchContainer')) {
        exitSearchMode();
    }
});

$('.js-doQuickSearch').on('touchstart click', function (e) {
    if ($('.js-quickSearchInput').val() !== '') {
        $('#nav-search').submit();
    }
});

//Toggle foundation accordion
$('.accordion.top-nav li, span.nav-panel-icon').on(
    'tap click',
    'a:eq(0), a:eq(1), span',
    function (e) {
        e.stopPropagation();

        var li_parent = $(this).parent();
        var openAccordion = $('.accordion.top-nav li div.content:visible');
        var accordionButton =
            this.tagName === 'A'
                ? $(this)
                : $(this).siblings('.nav-panel-name');

        if (li_parent.hasClass('active') && li_parent.hasClass('top-nav')) {
            li_parent.removeClass('active');
            accordionButton.attr('aria-expanded', 'false');
            openAccordion.toggle();
        } else if (li_parent.hasClass('top-nav')) {
            $('.accordion-navigation.top-nav').removeClass('active');
            li_parent.addClass('active');
            openAccordion
                .siblings('.nav-panel-name')
                .attr('aria-expanded', 'false');
            openAccordion.toggle();
            accordionButton.attr('aria-expanded', 'true');
            accordionButton.siblings('.content').toggle();
        }

        if (window.toaster) window.toaster._stickToast();
    }
);

// Remove desktop view searchbar autofocus on mobile devices
var mobile = bowser.mobile;
var tablet = bowser.tablet;

if (mobile || tablet) {
    $('.search-input').removeAttr('autofocus');
} else {
    $('.search-input').focus();
}

// TODO: Evaluate if this is still needed - MD
window.onorientationchange = function () {
    if (
        $('.search-input-mobile').css('display') != 'none' &&
        $('.search-input').css('display') == 'none' &&
        $('input:focus').length > 0 &&
        Math.abs(window.orientation) != 90
    ) {
        $('.js-mobileSearchInput').trigger('click');
    } else if (
        Math.abs(window.orientation) === 90 &&
        $('input:focus').length > 0
    ) {
        $('.search-input').trigger('click');
    } else if ($('input:focus').length > 0) {
        $('.js-mobileSearchInput').trigger('click');
    }
};

$('input[data-search]').click(function (e) {
    if (!$('input[data-search]').is(':focus')) {
        document.activeElement.blur();
        $(this).blur();
        var temp = $(this).val();
        $('input[data-search]').val(temp);
        $(this).focus();
        e.preventDefault();
    }
});

/**
 * Set tab indices for nav menu
 */

var resized = false;
$('#drop-collections')
    .on('opened.fndtn.dropdown', function (event) {
        $(this).find('a, h2').attr('tabindex', 0);

        if (!resized) {
            // Determine size of navigation based on # of columns
            var nav = $('#drop-collections');
            var columns = nav.find('ul:first-child').children('li');
            var columnCount = columns.length;
            var columnWidth = (1 / columnCount) * 100 + '%';

            columns.css('width', columnWidth);

            if (columnCount === 3) {
                columns.last().css('width', '200px');
            }

            nav.addClass('nav-' + columnCount + '-columns');
            resized = true;
        }
    })
    .on('closed.fndtn.dropdown', function () {
        $(this).find('a, h2').attr('tabindex', -1);
    });

$(
    '.Nav-collectionsLink, .Nav-myAccount--desktop, .Nav-partnerLibrariesLink'
).on('click keydown', function (event) {
    if (!isSelectEvent(event)) {
        return;
    }
    event.stopPropagation();
    closeNavDropdowns();
    window.Foundation.libs.dropdown.toggle($(this));
    if ($(this).hasClass('Nav-collectionsLink')) {
        renderKanopyAd();
    }
});

// Close nav when account or partner libraries dropdown is opened
$('#dropAccount, #rla-dropdown').on('opened.fndtn.dropdown', function (e) {
    window.Foundation.libs.dropdown.close($('#drop-collections'));
});

new DropdownWatcher(
    $('.js-desktopSearchContainer'),
    $('.js-toggleSearch'),
    () => {
        $('.js-desktopSearchContainer').hide();
        $('.js-desktopSearchContainer').attr('aria-hidden', 'true');
        $('.js-toggleSearch').attr('aria-expanded', 'false');
    }
);

const navbarFoundationDropdowns = [
    $('#drop-collections'),
    $('#dropAccount'),
    $('#rla-dropdown'),
];

navbarFoundationDropdowns.forEach((dropdown) => {
    new DropdownWatcher(dropdown);
});

$('.js-closeAdvantageTout').on('click tap', function () {
    Cookies.set('advantage-dismissed', '1', {
        path: '/',
        expires: 1,
        sameSite: 'lax',
        secure: true,
    });

    var accountSignInUrl = window.url(window.routes.accountSignIn);

    $('.js-advantageTout').hide();
    if (window.toaster) window.toaster._stickToast();
    $('a#account-holder-name, [data-dropdown="dropAccountMobile"]')
        .removeAttr('aria-haspopup data-options aria-controls')
        .attr({ href: accountSignInUrl, 'data-forward': '' });
    $(
        '#account-holder-name, li.account-dropdown-mobile a i.icon-account, [data-dropdown="dropAccountMobile"]'
    ).on('click', function (e) {
        e.stopPropagation();
    });
});
